import Login from "../Auth/components/Login";

function LoginPage() {
    return (
        <>
        <div>
            <Login/>
        </div>
        </>
    );
}

export default LoginPage;